import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import {
  ScreenTrackingService,
  UserTrackingService,
} from '@angular/fire/analytics';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { FooterService } from '@padspin/ui-footer';
import { HeaderComponent, HeaderService } from '@padspin/ui-header';
import { filter } from 'rxjs';
import { HeaderLoadingBarComponent } from '@padspin/ui-header-loading-bar';

import { FooterComponent } from '@padspin/ui-footer';
import { ToastComponent } from '@padspin/ui-toast';
import { HomerChatOutletComponent } from '@padspin/ui-homer-chat';
import { CurrentCustomClaimsService } from '@padspin/ui-rbac';
import { CallScriptHostComponent } from './call-script-host.component';

@Component({
  selector: 'padspin-frontend',
  template: `
    <padspin-header></padspin-header>
    <padspin-toast></padspin-toast>
    <section class="content md:pr-[var(--call-script-panel-width,0px)]">
      <padspin-header-loading-bar></padspin-header-loading-bar>
      <router-outlet></router-outlet>
    </section>
    @if (isFooterVisible()) {
      <padspin-footer class="md:pr-[var(--call-script-panel-width,0px)]" />
    }
    <padspin-homer-chat-outlet />
    @defer (when isStaff()) {
      <padspin-call-script-host />
    }
  `,
  styleUrls: ['./frontend.component.css'],
  imports: [
    HeaderComponent,
    HeaderLoadingBarComponent,
    RouterModule,
    ToastComponent,
    FooterComponent,
    HomerChatOutletComponent,
    CallScriptHostComponent,
  ],
  providers: [ScreenTrackingService, UserTrackingService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FrontendComponent {
  private readonly footerService = inject(FooterService);
  private readonly headerService = inject(HeaderService);
  private readonly router = inject(Router);
  private readonly claims = inject(
    CurrentCustomClaimsService,
  ).currentCustomClaims();

  protected readonly isStaff = computed(() => {
    const claims = this.claims();
    return claims?.admin === true || claims?.account_manager === true;
  });

  constructor() {
    // Clear any page-specific header state when navigating; the destination
    // page re-publishes its own menu + persona switch in ngOnInit (mirrors
    // FooterService).
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationStart),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.headerService.setMenuItems([]);
        this.headerService.setAltLandingLink(null);
      });
  }

  protected isFooterVisible = toSignal(this.footerService.getVisibility(), {
    initialValue: true,
  });
}
